export default __webpack_public_path__ + "static/media/ff_en.19dfae88.png";